import { encodeToBase64 } from '@shared/conversion/encodeToBase64';
import { IdConnectConfiguration } from '@idConnect/types';
import { idConnectStorage } from '@idConnect/helpers/idConnectStorage';

export const getStorageIdConnectCookie = (
  idConnectConfiguration: IdConnectConfiguration,
): string | null => {
  const sessionIdConnectStorageData = idConnectStorage(
    idConnectConfiguration.IDCONNECT_STORAGE_TYPE,
  ).get(idConnectConfiguration.IDCONNECT_DATA_STORAGE);
  const sessionConnectStorageData = idConnectStorage(
    idConnectConfiguration.IDCONNECT_STORAGE_TYPE,
  ).get(idConnectConfiguration.IDCONNECT_DATA_STORAGE);

  if (
    sessionConnectStorageData?.umid &&
    sessionIdConnectStorageData?.ids?.target?.umdid
  ) {
    return encodeToBase64(
      `${sessionIdConnectStorageData.ids.target.umdid}|${sessionConnectStorageData.umid}|1`,
    );
  }

  return null;
};
